var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHerdezGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_14809",
    "data-name": "Grupo 14809",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.97,
    height: 62.275,
    viewBox: "0 0 62.97 62.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_23",
    "data-name": "Rect\\xE1ngulo 23",
    width: 62.97,
    height: 62.275,
    fill: "#77777a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M102.419,0a3.034,3.034,0,0,0-3.034,3.034V13.718H85.373V0H74.395a3.034,3.034,0,0,0-3.034,3.034V41.107a54.4,54.4,0,0,1,7.428-1.41c3.187-.47,6.584-.627,6.584-.627V27.73H99.385V39.174s3.645.261,7.38.81a63.606,63.606,0,0,1,6.632,1.332V0Z",
    transform: "translate(-60.894)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M158.842,367.507v-6.638h1.472a1.329,1.329,0,0,1,1.338,1.354,1.171,1.171,0,0,1-1.17,1.308l-1.3.017a1.407,1.407,0,0,1,1.028.938c.66,2.079,1.144,3.934,2.891,4.186a2.938,2.938,0,0,0,1.414-.02.892.892,0,0,0,.166-.074l-.057-.049a3.938,3.938,0,0,1-.944-1.745,5.948,5.948,0,0,0-1.016-2.317,2.406,2.406,0,0,0,1.281-2.335,2.919,2.919,0,0,0-.829-2.218,3.2,3.2,0,0,0-2.178-.772h.009l-4.415.006v7.143c0,.857.163,1.217,1.185,1.217Z",
    transform: "translate(-133.571 -306.461)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M65.651,359.157s0,7.522,0,8.382H64.489c-1.022,0-1.184-.359-1.184-1.217v-2.016l-2.435,0v3.229H59.544c-.9,0-1.023-.245-1.023-1.052v-7.33l2.349-.006v3.215l2.435,0v-3.211Z",
    transform: "translate(-49.937 -306.47)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M311.05,359.193V361h3.915c-.382.481-3.667,4.6-3.667,4.6a1.172,1.172,0,0,0-.25.77v.015c0,.858.166,1.216,1.187,1.216h5.806v-1.642h-3.416c-.221,0-.309,0-.369-.143s.047-.272.219-.484l3.567-4.5v-1.641Z",
    transform: "translate(-265.423 -306.506)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M361.971,407.773V407.5h.044l.042,0a.175.175,0,0,1,.07.011.094.094,0,0,1,.055.058.307.307,0,0,1,.013.093c.006.043.009.079.015.107h.189l-.006-.024c0-.006,0-.016-.008-.019v-.093a.21.21,0,0,0-.067-.173.224.224,0,0,0-.105-.043.245.245,0,0,0,.131-.053.161.161,0,0,0,.052-.138.193.193,0,0,0-.1-.18.374.374,0,0,0-.149-.038c-.012,0-.065,0-.161,0h-.21v.764Zm.229-.531a.1.1,0,0,1-.042.091.17.17,0,0,1-.11.031h-.078v-.221h.051a.317.317,0,0,1,.114.015.085.085,0,0,1,.064.084m.563.148a.639.639,0,0,0-.2-.485.652.652,0,0,0-.487-.206.679.679,0,0,0-.474.188.67.67,0,0,0-.213.5.681.681,0,0,0,.2.491.7.7,0,0,0,.971,0,.658.658,0,0,0,.209-.494m-.688-.575a.551.551,0,0,1,.4.173.578.578,0,0,1,0,.808.567.567,0,0,1-.968-.407.566.566,0,0,1,.164-.4.552.552,0,0,1,.4-.173",
    transform: "translate(-308.378 -347.044)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M117.515,364.345V362.4H115.07V361h3.4v-1.806H112.76v6.688c0,.987,0,1.672,1.037,1.672h4.671v-1.806h-2.918a.516.516,0,0,1-.379-.105.781.781,0,0,1-.115-.525c0-.086.013-.726.013-.772Z",
    transform: "translate(-96.22 -306.506)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M272.262,364.345V362.4h-2.445V361h3.4v-1.806h-5.71v6.688c0,.987,0,1.672,1.037,1.672h4.673v-1.806H270.3a.518.518,0,0,1-.379-.105.787.787,0,0,1-.115-.525c0-.086.012-.726.012-.772Z",
    transform: "translate(-228.271 -306.506)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M214.4,365.964c-.706,0-.785-.52-.785-1.272v-3.757h.769a2.293,2.293,0,0,1,2.272,2.537c0,2.24-1.537,2.492-2.256,2.492m-3.094-6.753-.006,6.519c0,1.03.117,1.825,1.57,1.869.422.016,1.338.027,2.013,0,3.31,0,4.006-2.176,4.006-4.145,0-4.089-3.065-4.246-4-4.246Z",
    transform: "translate(-180.31 -306.522)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M146.548,324.9a5.862,5.862,0,0,1-1.6.245,2.854,2.854,0,0,1-1.95-.584,1.992,1.992,0,0,1-.676-1.573c.007-1.438,1.167-2.26,2.74-2.26a3.637,3.637,0,0,1,1.331.211l-.228.784a2.915,2.915,0,0,0-1.118-.186c-.9,0-1.587.462-1.587,1.4a1.371,1.371,0,0,0,1.509,1.419,1.6,1.6,0,0,0,.533-.065v-.905h-.74v-.764h1.786Z",
    transform: "translate(-121.445 -273.68)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M175.575,322.759H176c.541,0,.861-.244.861-.622,0-.4-.3-.6-.8-.6a2.934,2.934,0,0,0-.491.033ZM174.5,320.9a10.55,10.55,0,0,1,1.444-.09,2.648,2.648,0,0,1,1.551.341,1.054,1.054,0,0,1,.441.905,1.167,1.167,0,0,1-.846,1.065v.019a1.108,1.108,0,0,1,.64.809,12.04,12.04,0,0,0,.391,1.22h-1.111a5.109,5.109,0,0,1-.335-1.009c-.128-.539-.335-.687-.775-.693h-.328v1.7H174.5Z",
    transform: "translate(-148.905 -273.751)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M201.647,321.031v2.491c0,.745.313,1.124.869,1.124s.882-.36.882-1.124v-2.491h1.082v2.427a1.779,1.779,0,0,1-2,1.971,1.732,1.732,0,0,1-1.922-1.985v-2.414Z",
    transform: "translate(-171.14 -273.942)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M232.355,322.862a1.92,1.92,0,0,0,.363.025c.576,0,.932-.264.932-.706,0-.4-.306-.635-.847-.635a2.135,2.135,0,0,0-.449.037Zm-1.074-1.965a9.831,9.831,0,0,1,1.466-.09,2.485,2.485,0,0,1,1.466.348,1.22,1.22,0,0,1,.513,1,1.314,1.314,0,0,1-.442,1.027,2.384,2.384,0,0,1-1.558.456,3.042,3.042,0,0,1-.37-.019v1.547h-1.074Z",
    transform: "translate(-197.357 -273.751)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M256.689,322.793c0,.848.441,1.444,1.167,1.444s1.153-.629,1.153-1.47c0-.777-.413-1.444-1.16-1.444s-1.16.629-1.16,1.47m3.465-.058a2.17,2.17,0,0,1-2.355,2.28,2.117,2.117,0,0,1-2.257-2.2,2.2,2.2,0,0,1,2.335-2.266,2.117,2.117,0,0,1,2.276,2.19",
    transform: "translate(-218.06 -273.527)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M62.97,278.185s-10.081-6.358-32.237-6.358S0,278.185,0,278.185l2.2.648s7.967-3.036,28.592-3.036,30.482,3.036,30.482,3.036Z",
    transform: "translate(0 -231.955)",
    fill: "#77777a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerdezGris);
export default __webpack_public_path__ + "static/media/HerdezGris.63aef9dee48e3916e4473fab86c65d81.svg";
export { ForwardRef as ReactComponent };